import { Box, Button, Spinner, Text } from 'grommet';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { finalizeFieldProcessing, getFields } from '../../../../redux/actions/map-actions/field/field-action';
import { ModalBase } from './Common/ModalBase';
import { useAppSelector } from '../../../../redux';

const FinalizeIneligibleAreasModal = ({ closeModal }: { closeModal: () => void }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const journeyId = useAppSelector((state) => state.producer.journeyInformation.id);
  const fields = useAppSelector((state) => state.map.fields);
  const [loading, setLoading] = useState<boolean>(false);

  const wetlandsCount = fields.reduce((t, f) => t + (f.properties?.processedIneligibleBoundaries?.wetlands?.boundaries?.length ?? 0), 0);
  const publicLandsCount = fields.reduce((t, f) => t + (f.properties?.processedIneligibleBoundaries?.publicLands?.boundaries?.length ?? 0), 0);

  const onRemoveClick = (choices: string[]) => {
    setLoading(true);
    dispatch(
      finalizeFieldProcessing(journeyId, choices, () => {
        dispatch(getFields(journeyId));
        setLoading(false);
        closeModal();
      }),
    );
  };

  const RemoveButton = ({ text, dataCy, choices }: { text: string; dataCy: string; choices: string[] }): JSX.Element => {
    return (
      <Button
        data-cy={dataCy}
        onClick={() => {
          onRemoveClick(choices);
        }}
        style={{
          width: 'fit-content',
          borderWidth: '2px',
          borderStyle: 'solid',
          borderColor: '#FFE137',
          padding: '8px',
          textAlign: 'center',
          height: 'fit-content',
        }}>
        <Text weight={600} size={'12px'} style={{ lineHeight: 'unset' }}>
          {text}
        </Text>
      </Button>
    );
  };

  return (
    <ModalBase title={t('fieldFlow.fieldProcessing.finalizeModalTitle')}>
      <Box margin='1.5rem 0'>
        <Text
          style={{
            fontSize: '20px',
            lineHeight: '30px',
            textAlign: 'center',
          }}>{`We detected ${wetlandsCount} wetlands and ${publicLandsCount} public lands. What should be removed?`}</Text>
      </Box>
      {loading ? (
        <Box height={'100%'} align={'center'} justify={'center'}>
          <Spinner color={'#FFE137'} size={'large'} />
        </Box>
      ) : (
        <Box direction={'row'} gap={'8px'} justify={'between'}>
          <Button
            data-cy={'cancel-modal-button'}
            onClick={() => closeModal()}
            style={{
              width: 'fit-content',
              borderWidth: '2px',
              borderStyle: 'solid',
              borderColor: '#FFE137',
              padding: '8px',
              textAlign: 'center',
              height: 'fit-content',
            }}>
            <Text weight={600} size={'12px'} style={{ lineHeight: 'unset' }}>
              {'Back'}
            </Text>
          </Button>
          <Box direction={'row'} gap={'8px'} justify={'between'}>
            <RemoveButton dataCy={'no-removal-button'} text={'No removal'} choices={[]} />
            <RemoveButton dataCy={'public-lands-button'} text={'Public lands only'} choices={['PUBLIC_LANDS']} />
            <RemoveButton dataCy={'wetlands-button'} text={'Wetlands only'} choices={['WETLANDS']} />
            <RemoveButton dataCy={'remove-all-button'} text={'Remove all'} choices={['PUBLIC_LANDS', 'WETLANDS']} />
          </Box>
        </Box>
      )}
    </ModalBase>
  );
};

export default FinalizeIneligibleAreasModal;
